import React, { useState } from 'react';

const sameDay = (a, b) =>
  a && b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

export function Calendar({ value, onChange, minDate }) {
  const [view, setView] = useState(() => new Date(value.getFullYear(), value.getMonth(), 1));
  const y = view.getFullYear();
  const mo = view.getMonth();
  const startDow = new Date(y, mo, 1).getDay();
  const daysInMonth = new Date(y, mo + 1, 0).getDate();
  const min0 = new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate());
  const WD = ['日', '月', '火', '水', '木', '金', '土'];
  const cells = [];
  for (let i = 0; i < startDow; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(new Date(y, mo, d));
  const atMin = y === minDate.getFullYear() && mo === minDate.getMonth();

  return (
    <div className="cal">
      <div className="cal-head">
        <button type="button" className="cal-nav" onClick={() => setView(new Date(y, mo - 1, 1))} disabled={atMin} aria-label="前の月">
          ‹
        </button>
        <span className="cal-title">
          {y}年 {mo + 1}月
        </span>
        <button type="button" className="cal-nav" onClick={() => setView(new Date(y, mo + 1, 1))} aria-label="次の月">
          ›
        </button>
      </div>
      <div className="cal-wd">
        {WD.map((w, i) => (
          <span key={w} className={`cal-wd-c${i === 0 ? ' sun' : i === 6 ? ' sat' : ''}`}>
            {w}
          </span>
        ))}
      </div>
      <div className="cal-grid">
        {cells.map((d, i) => {
          if (!d) return <span key={`e-${i}`} className="cal-cell cal-cell--empty" />;
          const disabled = d < min0;
          const sel = sameDay(d, value);
          const dow = d.getDay();
          return (
            <button
              key={`d-${d.getTime()}`}
              type="button"
              className={`cal-cell${sel ? ' is-sel' : ''}${disabled ? ' is-dis' : ''}${!sel && dow === 0 ? ' sun' : ''}${!sel && dow === 6 ? ' sat' : ''}`}
              disabled={disabled}
              onClick={() => onChange(d)}
            >
              {d.getDate()}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export function EditSaveBar({ label = '変更を保存', onSave }) {
  return (
    <div className="edit-savebar">
      <button type="button" className="edit-save-btn" onClick={onSave}>
        {label}
      </button>
    </div>
  );
}

export function EditToast({ show, text }) {
  return (
    <div className={`edit-toast${show ? ' is-show' : ''}`}>
      <span className="edit-toast-ic">✓</span>
      {text}
    </div>
  );
}
